import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../../Containers/Config';
import { Constant } from '../../../../../Containers/Helpers/constant';
import apiCall from '../../../apiCall';
import { GET_USER_REGISTRATION_LIST, GET_USER_REGISTRATION_LIST_SUCCESS, GET_USER_REGISTRATION_LIST_ERROR } from '../../../actionType';

function* getUserRegistration({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/filereport`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        // 'Project-Code': 'GLOBE_TOYOTA',
        ...customHeaders,
      },
      data: payload?.data,
      // data: {
      //   type: 'USER_REGISTRATION',

      //   start_date: '01-01-2024',

      //   end_date: '11-12-2024',
      //   offset: 0,

      //   limit: 1,
      //   order_by: 'desc',
      //   // pageSize: Constant?.TABLE_PAGE_SIZE,
      // },
    });

    if (response.status === 200) {
      yield put({
        type: GET_USER_REGISTRATION_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_USER_REGISTRATION_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_USER_REGISTRATION_LIST_ERROR, payload: error });
  }
}

export function* watchGetUserRegistration() {
  yield takeEvery(GET_USER_REGISTRATION_LIST, getUserRegistration);
}

function* getUserRegistratioSaga() {
  yield all([fork(watchGetUserRegistration)]);
}

export default getUserRegistratioSaga;
